import LoadingPlaceholder from 'components/loader/LoadingPlaceholder';
import { BannerLoaderStyled } from './SiteAccess.styles';

const TITLE_LINE_COUNT = 18 / 14;
const BUTTON_LINE_COUNT = 34 / 14;

const SiteAccessBannerLoader = () => (
  <>
    <BannerLoaderStyled data-testid="premium-dbs-banner-loader">
      <LoadingPlaceholder linesCount={TITLE_LINE_COUNT} width="35%" />
      <LoadingPlaceholder width="70%" />
    </BannerLoaderStyled>
    <LoadingPlaceholder linesCount={BUTTON_LINE_COUNT} width="140px" />
  </>
);

export default SiteAccessBannerLoader;
